import React, { useState, useEffect } from "react";

const ZohoChatPopup = () => {
  useEffect(() => {
    const chat = document.getElementById("zoho-chat-popup");
    if (chat) {
      const handleClick = () => {
        if (window.$zohosq?.floatwindow?.open) {
          window.$zohosq.floatwindow.open();
        }
      };
      chat.addEventListener("click", handleClick);
      return () => chat.removeEventListener("click", handleClick);
    }
  }, []);

  const hidePop = () => {
    const element = document.getElementById("home-call-fixpop");
    if (element) {
      element.classList.add("hide");
    }
  };

  return (
    <div
      className="home-call-popup home-call-fixpop bg--white z-index--9 p--15 radius--16 text-center w--min-290 "
      id="home-call-fixpop"
    >
      <div className="p--relative">
        <span
          className="close-popup"
          onClick={(e) => {
            hidePop();
            e.stopPropagation();
          }}
        >
          <img
            src={`${"./../assets/images"}/cross-add-modal.svg`}
            alt="close icon"
            className="h--25 w-auto c--pointer"
          />
        </span>
        <span className="w--70 h--70 radius--50 overflow-hidden object-fit--cover bg--gray-f5 d-flex align-items-center justiffy-content-center m-auto border--4 border--orange">
          <img
            src={`${"./../assets/images"}/home-profile-img.svg`}
            alt="profile"
          />
        </span>
        <div className="font--24 mt--8 mb--8 text--black sf--d-bold">
          Welcome to Nxatel
        </div>
        <div
          className="text--blue-1d3f font--16 bg--light-yellow pt--7 pb--7 pr--10 pl--10 radius--50 c--pointer sf--d-semibold"
          id="zoho-chat-popup"
        >
          Speak to our sales team
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              textAlign: "center",
              flexDirection: "column",
              marginLeft: "50px",
            }}
          >
            <div className="text--blue-1d3f font--16 dm--sans">Call us on</div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="text--blue-1d3f font--20 dm--sans fw--700">
                086 169 2835
              </div>
            </div>
          </div>
          <div>
            <a href="https://api.whatsapp.com/send/?phone=27672607763&text&type=phone_number&app_absent=0">
              <img
                src="..\assets\images\new_index\whatsapp.svg"
                height={50}
                width={50}
                style={{
                  marginTop: "5px",
                  paddingLeft: "10px",
                }}
                alt="whatsapp"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const FloatingWidget = () => {
  const [visible, setVisible] = useState(false); // Starts as hidden
  const [showChatPopup, setShowChatPopup] = useState(false);

  const handleContactUsClick = () => {
    setVisible(false);
    setShowChatPopup(true);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 4000); // Show after 3 seconds
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {!showChatPopup && visible && (
        <div className="floating-widget">
          <button
            className="floating-widget__close"
            onClick={() => setVisible(false)}
          >
            &times;
          </button>
          <a href="/demo">
            <button className="floating-widget__button floating-widget__button--primary">
              Get A Demo
            </button>
          </a>
          <a href="/signup">
            <button className="floating-widget__button">Free Trial</button>
          </a>
          <button
            className="floating-widget__button"
            onClick={handleContactUsClick}
          >
            Contact Us
          </button>
        </div>
      )}

      {showChatPopup && <ZohoChatPopup />}
    </>
  );
};

export default FloatingWidget;
